import React, { useEffect, useState, useContext, useCallback } from "react";

// #region Components
import Input from "shared/components/FormElements/Input";
import CustomSelect from "shared/components/FormElements/Select";
import DatePicker from "shared/components/FormElements/DatePicker";
import Button from "shared/components/FormElements/Button";
import Card from "shared/components/UIElements/Card";
import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";
import ErrorModal from "shared/components/UIElements/ErrorModal";
import Modal from "shared/components/UIElements/Modal";
// #endregion Components

// #region Utils
import { VALIDATOR_REQUIRE } from "shared/util/validators";
// #endregion Utils

// #region Hooks
import { useForm } from "shared/hooks/form-hook";
import { useHttpClient } from "shared/hooks/http-hook";
import { AuthContext } from "shared/context/auth-context";
import { StoreContext } from "shared/context/store-context";
// #endregion Hooks

import "./AccountingItem.css";

const ServiceTemplateItem = (props) => {
  const auth = useContext(AuthContext);
  const store = useContext(StoreContext);

  const [itemstate, setItemState] = useState();
  const [loadedItem, setLoadedItem] = useState();

  const itemId = props.itemid;
  //const updateStoreItems = store.UpdateAccountingUtils();

  const ItemTypeTR = "Hizmet Şablonu";
  const ItemType = "serviceTemplate";
  const ItemEndPointType = "servicetemplates";

  // #region Standard Interface functions
  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const showDeleteWarningHandler = () => {
    setShowConfirmModal(true);
  };

  const cancelDeleteHandler = () => {
    setShowConfirmModal(false);
  };
  // #endregion Standard Interface functions

  // #region Standard API calls
  const fetchItem = useCallback(async () => {
    try {
      const responseData = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/${ItemEndPointType}/${itemId}`);
      setLoadedItem(responseData[ItemType]);
      setItemState(Date.now().toString());
    } catch (err) {}
  }, [sendRequest, itemId]);

  const confirmDeleteHandler = async () => {
    setShowConfirmModal(false);
    try {
      await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/${ItemEndPointType}/${itemId}`, "DELETE", null, {
        "Content-Type": "application/json",
      });
      setItemState(Date.now());
      store.UpdateAccountingUtils();
      setLoadedItem(null);
      //   history.push(`/${ItemEndPointType}`);
    } catch (err) {}
  };
  // #endregion Standard API calls

  useEffect(() => {
    fetchItem();
  }, [itemId, fetchItem]);

  const [formState, inputHandler] = useForm(
    {
      year: { value: null, isValid: true },
      name: { value: "", isValid: true },
      serviceStartDate: { value: "", isValid: true },
      serviceEndingDate: { value: "", isValid: true },
      amount: { value: null, isValid: true },
    },
    true
  );

  const itemUpdateSubmitHandler = async (event) => {
    event.preventDefault();
    let responseData;
    try {
      responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/${ItemEndPointType}/${itemId}`,
        "PATCH",
        JSON.stringify({
          year: formState.inputs.year.value,
          name: formState.inputs.name.value,
          serviceStartDate: formState.inputs.serviceStartDate.value,
          serviceEndingDate: formState.inputs.serviceEndingDate.value,
          amount: formState.inputs.amount.value,
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );

      setLoadedItem(responseData[ItemType]);
      setItemState(Date.now());
      store.UpdateAccountingUtils();
    } catch (err) {}
  };

  if (isLoading) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!loadedItem && !error) {
    return (
      <div className="center">
        <Card>
          <h2>{ItemTypeTR} bulunamadı.</h2>
        </Card>
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <Modal
        show={showConfirmModal}
        onCancel={cancelDeleteHandler}
        header="Emin misiniz?"
        footerClass="place-item__modal-actions"
        footer={
          <React.Fragment>
            <Button inverse onClick={cancelDeleteHandler}>
              Hayır
            </Button>
            <Button danger onClick={confirmDeleteHandler}>
              Evet
            </Button>
          </React.Fragment>
        }
      >
        <p>{ItemTypeTR} silme işlemini onaylıyor musunuz? Bu işlem geri alınamaz.</p>
      </Modal>

      {!isLoading && loadedItem && (
        <form key={itemstate} className="item-form" onSubmit={itemUpdateSubmitHandler}>
          <div className="button-container">
            <Button type="button" danger onClick={props.onClose}>
              &#60; Geri
            </Button>
          </div>

          <CustomSelect
            options={store.educationYearsOptions}
            id="year"
            onInput={inputHandler}
            label="Eğitim-Öğretim Yılı"
            initialValid={true}
            initialValue={store.educationYearsOptions.find(
              (item) => item.value.toString() === loadedItem.year.toString()
            )}
          ></CustomSelect>

          <Input
            id="name"
            element="input"
            type="text"
            label="İsim"
            validators={[VALIDATOR_REQUIRE()]}
            errorText="İsim giriniz."
            initialValue={loadedItem.name}
            initialValid={true}
            onInput={inputHandler}
          />

          <DatePicker
            id="serviceStartDate"
            onInput={inputHandler}
            label="Hizmet Başlangıç Tarihi"
            initialValid={true}
            validators={[VALIDATOR_REQUIRE()]}
            initialValue={loadedItem.serviceStartDate.toString()}
          ></DatePicker>

          <DatePicker
            id="serviceEndingDate"
            onInput={inputHandler}
            label="Hizmet Bitiş Tarihi"
            initialValid={true}
            validators={[VALIDATOR_REQUIRE()]}
            initialValue={loadedItem.serviceEndingDate.toString()}
          ></DatePicker>

          <Input
            id="amount"
            element="input"
            type="text"
            label="Toplam Ücret"
            validators={[VALIDATOR_REQUIRE()]}
            errorText="Hizmet bedelinin standart ücretini giriniz."
            initialValue={loadedItem.amount}
            initialValid={true}
            onInput={inputHandler}
          />

          <div className="button-container">
            <Button type="submit" disabled={!formState.isValid}>
              Güncelle
            </Button>

            <Button type="button" danger onClick={showDeleteWarningHandler}>
              SİL
            </Button>
          </div>
        </form>
      )}
    </React.Fragment>
  );
};

export default ServiceTemplateItem;
